import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface AccessManagementUser {
  userId: string;
  emailAddress: string;
  userPassword: string;
  userType: string;
  userAlias: string;
  orgId: string;
  dpList: string;
  isActive: number;
  pubsList: string;
}

interface UserManagementState {
  currentOrgId: string | null;
  users: AccessManagementUser[];
}

const initialState: UserManagementState = {
  currentOrgId: null,
  users: []
};

const userManagementSlice = createSlice({
  name: 'userManagement',
  initialState,
  reducers: {
    setUsersForOrg: (
      state,
      action: PayloadAction<{ orgId: string; users: AccessManagementUser[] }>
    ) => {
      state.currentOrgId = action.payload.orgId;
      state.users = action.payload.users;
    },
    resetUsersForOrg: () => initialState
  }
});

export const { setUsersForOrg, resetUsersForOrg } = userManagementSlice.actions;

export default userManagementSlice.reducer;
